// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ab402912","732":"d8763001","977":"7b7532b0"}[chunkId] + ".chunk.js";
};